import { formatCurrency, formatPercentage } from '@/common/utils/formatters'
import { ArrowDownIcon, ArrowUpIcon } from 'lucide-react'

interface ProposalGroupHeaderProps {
  title: string
  countDisplay: string
  totalValueSum: number
  originalValueSum?: number
}

const ProposalGroupHeader = ({ title, countDisplay, totalValueSum, originalValueSum }: ProposalGroupHeaderProps) => {
  const hasModification = originalValueSum != null && originalValueSum !== totalValueSum

  const valueClassName = hasModification && totalValueSum > originalValueSum ? 'text-danger-soft' : 'text-valid'

  const differencePercentage =
    hasModification && originalValueSum ? (totalValueSum - originalValueSum) / originalValueSum : 0

  return (
    <div className="flex flex-col">
      <p className="font-bold text-base">{title}</p>

      <div className="flex items-center gap-0.5 text-xs">
        <span>{countDisplay}</span>

        <span>•</span>

        <span className="flex items-center gap-1">
          <span className={valueClassName}>{formatCurrency(totalValueSum)}</span>

          {hasModification && (
            <span className="text-white-400 line-through">{formatCurrency(originalValueSum)}</span>
          )}

          {differencePercentage !== 0 && (
            <span className="text-[9px] text-white-800 rounded-full px-1 bg-yellow-op-2 inline-flex items-center">
              {differencePercentage > 0 ? (
                <ArrowUpIcon className="size-3 text-danger-soft" />
              ) : (
                <ArrowDownIcon className="size-3 text-valid" />
              )}
              {formatPercentage(Math.abs(differencePercentage))}
            </span>
          )}
        </span>
      </div>
    </div>
  )
}

export default ProposalGroupHeader
